import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "app/shadcnComponents/ui/button";
import { cn } from "app/lib/utils";

interface SendButtonProps {
  readonly disabled?: boolean;
  readonly onClick?: () => void;
  readonly hasMessage?: boolean;
}

/**
 * SendButton component displays a send arrow button with dynamic styling.
 * Based on Figma design node 676-1587.
 *
 * @param disabled - If true, button is disabled and shows inactive color
 * @param onClick - Click handler for the button
 * @param hasMessage - If true and not disabled, shows active color. Otherwise shows inactive color.
 */
export default function SendButton({
  disabled = false,
  onClick,
  hasMessage = false,
}: SendButtonProps) {
  return (
    <Button
      variant="primary"
      size="icon"
      onClick={onClick}
      disabled={disabled || !hasMessage}
      className={cn(
        "!w-6 !h-6 !rounded-[32px] !p-[3px]",
        "flex items-center justify-center"
      )}
      aria-label="Send message"
    >
      <FontAwesomeIcon
        icon={["far", "arrow-up"]}
        className="text-white text-[12px] leading-[14px]"
      />
    </Button>
  );
}
